exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".regions__item[data-v-62279f33] {\n  cursor: pointer;\n}", ""]);

// exports
